import type { Trace, Transaction } from '@engine/models'

export const TRACE_SERVICES = [
  'rating',
  'dispatching',
  'ebol',
  'tracking',
  'profinder',
  'documents',
  'invoice',
  'provisioning',
  'fv-api',
] as const

export const getTraceError = (trace: Trace): Transaction | undefined =>
  trace.transactions?.find(transaction => transaction.error)

export const getTraceDuration = (trace: Trace): number | undefined => {
  const durations = (trace.transactions ?? [])
    .map(transaction => transaction.duration)
    .filter((duration): duration is number => duration !== undefined)

  return durations.length ? Math.max(...durations) : undefined
}
